import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { Provider } from 'react-redux';
import store from './redux/';
import './index.css';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports'; // If using Amplify CLI-generated config file
import { ErrorBoundary } from './components/errors/ErrorBoundary';
import { PageErrorFallback } from './components/errors/PageErrorFallback';


// Configure Amplify
Amplify.configure(awsconfig);


const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <StrictMode>
    {/*
      Last-resort boundary. Page-level crashes are caught closer to the leaf by
      RouteErrorBoundary inside the layouts; this one only fires if a provider or
      the layout itself blows up, which would otherwise leave a blank document.
    */}
    <ErrorBoundary
      source="app-root"
      fallback={(error, reset) => (
        <PageErrorFallback
          error={error}
          reset={reset}
          title="The application failed to load"
        />
      )}
    >
      <HelmetProvider>
        <Provider store={store}>
          <App />
        </Provider>
      </HelmetProvider>
    </ErrorBoundary>
  </StrictMode>
);

